import Cookies from "js-cookie";

export default () => {
    Cookies.remove("basket_id");
    Cookies.remove("basket_items_amount");
};
